import { Outlet } from 'react-router-dom';

export default function FullScreenLayout() {
  return (
    <div className='[>_*:flex-1] [>_*:min-h-0] fixed inset-0 flex flex-col'>
      <Outlet />
    </div>
  );
}
